
<app-bread-crumb [items]="[{text:'socios'}]" [sectionTitle]="'Lista de Socios'"></app-bread-crumb>

<section class="content">

  <div class="row">
    <div class="col-md-12">

      <ng-box [boxIcon]="'fa fa-users'" [boxTitle]="'Sócio'">

               <!-- cabesalho do box -->
               <ng-container class="ng-box-header">

                <ng-button
                  *ngIf="isAdminOrManager() || isUserKhuzela()"
                  (click)="create()"
                  [button]="{name:'novo sócio', faIconClass:'fa fa-plus',color:'danger'}">
                </ng-button>

              </ng-container>

              <!-- conteudo -->
        <ng-container class="ng-box-content">
             <ng-table  [tableHeaderAndFooterColumns]="tableProprieties()" *ngIf="!isSpinnerLoading">

                  <tr *ngFor="let member of objects;index" ngChangeColorOnHover>

                    <td>{{member?.member_number}}</td>
                    <td>{{member?.name}}</td>
                    <td>{{member?.email}}</td>
                    <td>{{member?.phone}}</td>
                    <td *ngIf="isAdminOrUserKhuzela()" [ngStyle]="{color:member?.club?.color}">{{member?.club?.name}}</td>
                    <td style="color:#f35309">{{member?.quote?.quota_description}}</td>
                    <td>{{member?.status_user}}</td>

                    <ng-actions-table-bar>
                      <ng-button
                       *ngIf="isAll()"
                        title="Editar"
                        (click)="edit(member)"
                        [button]="{faIconClass:'fa fa-edit',color:'danger'}"
                      ></ng-button>
                      <ng-button
                       *ngIf="isAll()"
                        title="Detalhe"
                        (click)="detail(member)"
                        [button]="{faIconClass:'fa fa-eye',color:'danger'}"
                      ></ng-button>
                      <ng-button

                        title="Excluir"
                        (click)="delete(member)"
                        [button]="{faIconClass:'fa fa-close',color:'danger'}"
                      ></ng-button>
                    </ng-actions-table-bar>

                </tr>

          </ng-table>
          <!-- fim da tabela -->
          <box-loading class="overlay" *ngIf="isSpinnerLoading"></box-loading>

        </ng-container>
      <!-- fim do conteudo -->
      </ng-box>
      <!-- fim do box -->

    </div>
  </div>
</section>
